import { Chrono } from "../../chrono.js";
import { ParsingResult, ParsingComponents, ReferenceWithTimezone } from "../../results.js";
import { Meridiem, Weekday } from "../../types.js";
import ENDefaultConfiguration from "./configuration.js";
export { Chrono, ParsingResult, ParsingComponents, ReferenceWithTimezone };
export { Meridiem, Weekday };
const enConfig = new ENDefaultConfiguration();
export const casual = new Chrono(enConfig.createCasualConfiguration(false));
export const strict = new Chrono(enConfig.createConfiguration(true, false));
export const GB = new Chrono(enConfig.createConfiguration(false, true));
export function parse(text, ref, option) {
    return casual.parse(text, ref, option);
}
export function parseDate(text, ref, option) {
    return casual.parseDate(text, ref, option);
}
//# sourceMappingURL=index.js.map